import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=65248968&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=js&"
export * from "./deleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65248968",
  null
  
)

export default component.exports